import React from "react";
import { Pagination } from "react-bootstrap";

const ResponsivePagination = ({ pageCount, currentPage, handlePageClick }) => {
  // Adjust max visible pages based on screen width
  const maxVisiblePages = window.innerWidth < 576 ? 3 : 5;
  let pages = [];

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > pageCount) {
    endPage = pageCount;
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  // Add first page & ellipsis if needed
  if (startPage > 1) {
    pages.push(
      <Pagination.Item key={1} onClick={() => handlePageClick(1)}>
        1
      </Pagination.Item>
    );
    if (startPage > 2) {
      pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }
  }

  // Page numbers
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <Pagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => handlePageClick(i)}
      >
        {i}
      </Pagination.Item>
    );
  }

  // Add ellipsis & last page if needed
  if (endPage < pageCount) {
    if (endPage < pageCount - 1) {
      pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }
    pages.push(
      <Pagination.Item key={pageCount} onClick={() => handlePageClick(pageCount)}>
        {pageCount}
      </Pagination.Item>
    );
  }

  return (
    <Pagination className="justify-content-center flex-wrap my-5 gap-2">
      <Pagination.First
        disabled={currentPage === 1}
        onClick={() => handlePageClick(1)}
      />
      <Pagination.Prev
        disabled={currentPage === 1}
        onClick={() => handlePageClick(currentPage - 1)}
      />
      {pages}
      <Pagination.Next
        disabled={currentPage === pageCount}
        onClick={() => handlePageClick(currentPage + 1)}
      />
      <Pagination.Last
        disabled={currentPage === pageCount}
        onClick={() => handlePageClick(pageCount)}
      />
    </Pagination>
  );
};

export default ResponsivePagination;
